/**
 * 比较大小的系列函数
 * @param {*} param
 * @return param.a ? param.b
 */

const lessThan = {
    fn: (a, b) => a < b,
    desc: '需要两个参数(a, b)，返回 a < b',
};

const notLessThan = {
    fn: (a, b) => a >= b,
    desc: '需要两个参数(a, b)，返回 a >= b',
};

const greaterThan = {
    fn: (a, b) => a > b,
    desc: '需要两个参数(a, b)，返回 a > b',
};

const notGreaterThan = {
    fn: (a, b) => a <= b,
    desc: '需要两个参数(a, b)，返回 a <= b',
};

/* eslint-disable eqeqeq */
const equalTo = {
    fn: (a, b) => a == b,
    desc: '需要两个参数(a, b)，返回 a == b',
};

const notEqualTo = {
    fn: (a, b) => a != b,
    desc: '需要两个参数(a, b)，返回 a != b',
};
/* eslint-enable eqeqeq */

const strictEqualTo = {
    fn: (a, b) => a === b,
    desc: '需要两个参数(a, b)，返回 a === b',
};

const notStrictEqualTo = {
    fn: (a, b) => a !== b,
    desc: '需要两个参数(a, b)，返回 a !== b',
};

import lodashIncludes from 'lodash/includes';

const includedIn = {
    fn: (a, b) => lodashIncludes(b, a),
    desc: '需要两个参数(a, b)，返回a是否存在于b中',
};

const notIncludedIn = {
    fn: (a, b) => !lodashIncludes(b, a),
    desc: '需要两个参数(a, b)，返回a是否不存在于b中',
};

export default {
    lessThan,
    notLessThan,
    greaterThan,
    notGreaterThan,
    equalTo,
    notEqualTo,
    strictEqualTo,
    notStrictEqualTo,
    includedIn,
    notIncludedIn,
};
